import {z} from 'zod';
import {Field} from '@/components/ui/Field';
import type {ApiCustomer} from '@/types/api';

const contactSchema = z.object({
  name: z.string().trim().min(2, 'Укажите имя').max(80, 'Слишком длинное имя'),
  phone: z
    .string()
    .trim()
    .min(6, 'Укажите телефон')
    .max(30, 'Слишком длинный номер')
    .regex(/^[+\d][\d\s()-]{5,}$/, 'Только цифры, пробелы и +()-'),
  car: z.string().trim().max(120, 'Слишком длинно').optional(),
  comment: z.string().trim().max(500, 'Слишком длинно').optional(),
});

export type ContactFormErrors = Partial<Record<keyof ApiCustomer, string>>;

export function validateContact(values: ApiCustomer): ContactFormErrors {
  const parsed = contactSchema.safeParse(values);
  if (parsed.success) return {};
  const errors: ContactFormErrors = {};
  for (const issue of parsed.error.issues) {
    const key = issue.path[0];
    if (typeof key === 'string' && !(key in errors)) {
      errors[key as keyof ApiCustomer] = issue.message;
    }
  }
  return errors;
}

export function hasContactErrors(errors: ContactFormErrors): boolean {
  return Object.keys(errors).length > 0;
}

export function ContactForm({
  value,
  onChange,
  errors,
  showErrors,
}: {
  value: ApiCustomer;
  onChange: (next: ApiCustomer) => void;
  errors: ContactFormErrors;
  showErrors: boolean;
}) {
  const err = (key: keyof ApiCustomer) => (showErrors ? errors[key] : undefined);

  return (
    <div className="flex flex-col gap-5">
      <Field label="Имя" value={value.name} onChange={(e) => onChange({...value, name: e.target.value})} error={err('name')} autoComplete="name" />
      <Field
        label="Телефон"
        type="tel"
        placeholder="+7 999 123-45-67"
        value={value.phone}
        onChange={(e) => onChange({...value, phone: e.target.value})}
        error={err('phone')}
        autoComplete="tel"
      />
      <Field
        label="Автомобиль"
        placeholder="Марка и модель"
        value={value.car ?? ''}
        onChange={(e) => onChange({...value, car: e.target.value})}
        error={err('car')}
        autoComplete="off"
      />
    </div>
  );
}
